import {createSlice} from '@reduxjs/toolkit';
import {
  TABLE_DISPLAY_MODE_ACTIONS,
  TABLE_DISPLAY_MODE_FEATURES
} from "../../pages/user/constants";
import {
  BLOG_STATE_ACTIVE,
  BLOG_STATE_DRAFT,
  BLOG_STATE_INACTIVE,
  BLOG_TAB_TAGS,
  MAX_TAGS_ALLOWED
} from "../../pages/blogs/constants";
import {setPaginatedItems} from "../../helpers/helperFunctions";
import {isEqual} from "lodash";

const initialState = {

  [BLOG_STATE_DRAFT]: {
    meta: {
      page: 1,
      totalPages: -1
    },
    pageData: {}
  },
  [BLOG_STATE_ACTIVE]: {
    meta: {
      page: 1,
      totalPages: -1
    },
    pageData: {}

  },
  [BLOG_STATE_INACTIVE]: {
    meta: {
      page: 1,
      totalPages: -1
    },
    pageData: {}

  },
  [BLOG_TAB_TAGS]: {
    meta: {
      page: 1,
      totalPages: -1
    },
    pageData: {}

  },
  selectedTab: BLOG_STATE_ACTIVE,
  template: {
    loading: false,
    error: '',
    data: [],
    init: false
  },
  modals: {
    form: {},
    confirm: {},
    confirmBlog: {},
    tagCrud: {}
  },
  create: {
    content: {},
    published: false,
    tags: [],
    details: {
      loading: false,
      error: '',
      data: {},
      init: false
    },
    tag: {
      loading: false
    },
    mainTitle: "",
    showTips: false,
    data: {
      title: "",
      seoDetails: {
        title: "",
        description: "",
        slug: "",
        image: ""
      }
    }
  }
};

const manageBlogSlice = createSlice({
  name: 'manageBlog',
  initialState: initialState,
  reducers: {


    setBlogs: (state, action) => setPaginatedItems(state, action),
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload?.tab ? action.payload.tab : state.selectedTab;
    },
    setBlogPublished: (state, action) => {
      state.create.published = action.payload?.published ?? true;
    },

    setManageBlogModals: (state, action) => {
      if (action.payload?.modal) {
        const type = action.payload.isConfirm ? 'confirm' : action.payload.isConfirmBlog ? 'confirmBlog' : action.payload.isTag ? 'tagCrud' : 'form';
        state.modals[type].data = action.payload.data;
        state.modals[type].modal = action.payload.modal;
        state.modals[type].ext = action.payload.ext;
      } else {
        state.modals = {...initialState.modals};
      }
    },
    setCurrentPage: (state, action) => {
      state[action.payload.type ?? state.selectedTab].meta.page = action.payload.page;
    },
    setBlogCreateData: (state, action) => {
      if (action.payload.title !== undefined) {
        state.create.mainTitle = action.payload.title;
      }
      if (action.payload.seoDetails?.title !== undefined) {
        state.create.data.seoDetails.title = action.payload.seoDetails.title;
      }
      if (action.payload.seoDetails?.description !== undefined) {
        state.create.data.seoDetails.description = action.payload.seoDetails.description;
      }
      if (action.payload.seoDetails?.image !== undefined) {
        state.create.data.seoDetails.image = action.payload.seoDetails.image;
      }
      if (action.payload.seoDetails?.slug !== undefined) {
        state.create.data.seoDetails.slug = action.payload.seoDetails.slug;
      }
      if (action.payload.content !== undefined) {
        if (!isEqual({...state.create.content, time: 1}, {...action.payload.content, time: 1})){
          state.create.content = action.payload.content;
        }

      }

      if (action.payload.clear) {
        state.create.data = {...initialState.create.data};
      }
    },
    setBlogTags: (state, action) => {
      if (action.payload.removeAll) {
        state.create.tags = [];
      } else if (action.payload.remove) {
        state.create.tags = state.create.tags.filter((t) => t.id !== action.payload.remove.id);
      } else if (action.payload.tags) {
        state.create.tags = action.payload.tags;
      } else {
        if (state.create.tags.length < MAX_TAGS_ALLOWED && !state.create.tags.some((t) => t.id === action.payload.tag.id)) {
          state.create.tags = [action.payload.tag, ...state.create.tags];
        }
      }
    },
    setBlogDetails: (state, action) => {
      if (action.payload.loading !== undefined) {
        state.create.details.error = '';
        state.create.details.loading = action.payload.loading;
      } else if (action.payload.clear) {
        state.create.details = {...initialState.create.details};
      } else {
        state.create.details.error = action.payload.error;
        state.create.details.loading = false;
        if (!action.payload.error) {

          state.create.details.init = true;
          state.create.details.data = action.payload.data;
          state.create.content = action.payload.data.data;

        }
      }
    },
    setBlogTagsCreating: (state, action) => {
      if (action.payload.loading !== undefined) {
        state.create.tag.loading = action.payload.loading;
        state.create.tag.data = action.payload.data;
      } else if (action.payload.clear) {
        state.create.tag = {...initialState.create.tag};
      }
    },
    setAdminsTableMode: (state, action) => {
      state.displayMode = action.payload?.mode ? action.payload.mode : (state.displayMode === TABLE_DISPLAY_MODE_FEATURES ? TABLE_DISPLAY_MODE_ACTIONS : TABLE_DISPLAY_MODE_FEATURES);
    },
    setShowTips: (state, action) => {
      state.showTips = action.payload.show !== undefined ? action.payload.show : true;
    },
    resetBlogTabs: (state, action) => {
      if (action.payload?.active) {
        state[BLOG_STATE_ACTIVE] = {...initialState[BLOG_STATE_ACTIVE]};
      }
      if (action.payload?.inactive) {
        state[BLOG_STATE_INACTIVE] = {...initialState[BLOG_STATE_INACTIVE]};
      }
      if (action.payload?.draft) {
        state[BLOG_STATE_DRAFT] = {...initialState[BLOG_STATE_DRAFT]};
      }
      if (action.payload?.selectedTab) {
        state.selectedTab = action.payload.selectedTab;
      }
      if (action.payload?.tags) {
        state[BLOG_TAB_TAGS] = {...initialState[BLOG_TAB_TAGS]};
      }

    },
    updateBlogTabData: (state, action) => {
      const sel = action.payload.type ?? state.selectedTab;
      const currentPage = state[sel].meta.page;

      if (state[sel].pageData[currentPage]) {
        state[sel].pageData[currentPage].data = state[sel].pageData[currentPage].data.map((blog) => blog.id === action.payload.data.id ? action.payload.data : blog);
      }


    },
    resetManageBlogs: (state) => initialState,


    tryLoadBlogs: () => {
    },
    tryLoadTags: () => {
    },
    tryLoadBlogDetail: () => {
    },
    tryAddOrUpdateBlogTags: () => {
    },
    tryDeleteBlogTag: () => {
    },
    tryAddNewBlog: () => {
    },
    tryUpdateBlogContents: () => {
    },
    tryAddNewTagAndUpdateInBlog: () => {
    }

  }
});

export const {
  tryLoadBlogs,
  tryLoadTags,
  resetManageBlogs,
  setCurrentPage,
  setBlogs,
  setSelectedTab,
  setManageBlogModals,
  setBlogCreateData,
  setBlogTags,
  resetBlogTabs,
  updateBlogTabData,
  tryAddOrUpdateBlogTags,
  tryDeleteBlogTag,
  tryAddNewBlog,
  tryUpdateBlogContents,
  tryLoadBlogDetail,
  setBlogDetails,
  setBlogPublished,
  setBlogTagsCreating,
  tryAddNewTagAndUpdateInBlog,
  setShowTips
} = manageBlogSlice.actions;

export default manageBlogSlice.reducer;
